<template>
  <resource-edit-wrapper
    :title="$t('resources.headers.edit_header')"
    :need-modal="showModal"
    :show-bottom-actions="true"
    @saveAction="$refs['headerForm'].submit()">
    <HeaderForm is-edit :header="item" @isDirtyForm="isDirtyForm" ref="headerForm"></HeaderForm>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import HeaderForm from "@/components/forms/HeaderForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceEditWrapper,
      HeaderForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    created() {
      this.$admin.toast.info(this.$t("generic.edit_warning.warning") + this.$t("generic.edit_warning.header"));
    },
  };
</script>
